import { Component, Element, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-card-bg',
  styleUrl: 'card-bg.css',
  shadow: true,
})
export class CardBg {
  @Element() host: HTMLElement;

  @Prop() backgroundImage : string;
  @Prop() backgroundColor : string = 'var(--cwc-color-primary)';
  @Prop() hoverOpacity    : string = "0.5";
  @Prop() borderRadius    : string = "0";
  @Prop() textColor       : string = "var(--cwc-color-white, #fff)";
  @Prop() textColorHover  : string = "var(--cwc-color-white, #fff)";
  @Prop() textAlign       : string = "left";
  @Prop() type            : string = "a";

  render() {
    return (
      <Host
        style={{
          backgroundImage: this.backgroundImage ? `url(${this.backgroundImage})` : '',
          "--text-align": this.textAlign,
          "--border-radius": this.borderRadius,
          "--hover-opacity": this.hoverOpacity,
          "--text-color": this.textColor,
          "--text-color-hover": this.textColorHover,
        }}
        class={`type-${this.type}`}
      >
        <div
          class="tinted-bg"
          style={{
            backgroundColor: this.backgroundColor,
          }}
          data-hover-opacity={this.hoverOpacity}
        ></div>
        <div class="content-container">
          <slot></slot>
        </div>
      </Host>
    );
  }

}
